import { render, staticRenderFns } from "./modal-copy.vue?vue&type=template&id=4276a6ef"
import script from "./modal-copy.vue?vue&type=script&lang=js"
export * from "./modal-copy.vue?vue&type=script&lang=js"
import style0 from "./modal-copy.vue?vue&type=style&index=0&id=4276a6ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports